import React from 'react';
import { useAuth } from 'api';
import { Loading } from 'ui';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import View from './View';
import ChangePassword from './ChangePassword';


export default function Company() {
  const {path, url} = useRouteMatch();
  const auth = useAuth();
  
  if(!auth) {
    return <Loading/>;
  }
  
  return (
    <Switch>
      <Route path={`${path}/view`} component={View}/>
      <Route path={`${path}/change-password`} component={ChangePassword}/>
      <Redirect to={`${url}/view`}/>
    </Switch>
  );
}